import { render, staticRenderFns } from "./HeadlessMultiselect.vue?vue&type=template&id=af4accd0&scoped=true"
import script from "./HeadlessMultiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeadlessMultiselect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeadlessMultiselect.vue?vue&type=style&index=0&id=af4accd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4accd0",
  null
  
)

export default component.exports